module.exports = {
  email: 'jafrydeep2@gmail.com',

  socialMedia: [
    {
      name: 'Upwork',
      url: 'https://www.upwork.com/freelancers/jafrydeep',
    },
    {
      name: 'GitHub',
      url: 'https://github.com/jafrydeep2',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/jafrydeep',
    },
    // {
    //   name: 'Instagram',
    //   url: 'https://www.instagram.com/_jafry',
    // },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Studies',
      url: '/#studies',
    },
    {
      name: 'Work',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#64ffda',
    navy: '#0A192F',
    darkNavy: '#0A192F',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
